import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-payment-option2',
    templateUrl: './payment-option2.component.html',
    styleUrls: ['./payment-option2.component.scss'],
    standalone: false
})
export class PaymentOption2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
